import { render, staticRenderFns } from "./EditParameter.vue?vue&type=template&id=4f884873&scoped=true&"
import script from "./EditParameter.vue?vue&type=script&lang=js&"
export * from "./EditParameter.vue?vue&type=script&lang=js&"
import style0 from "./EditParameter.vue?vue&type=style&index=0&id=4f884873&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f884873",
  null
  
)

export default component.exports